export default __webpack_public_path__ + "static/media/GoogleNetwork.9c6ced87.png";